/**
 * Pave API
 * Pave API Documentation
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { ApiRequestQrCodeAuthLoginModel } from '../model/models';
import { ApiResponseAuthRefreshModel } from '../model/models';


import { Configuration }                                     from '../configuration';



export interface QrCodeAuthServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * 
     * 
     */
    qrCodeAuthControllerGetCode0(extraHttpRequestParams?: any): Observable<string>;

    /**
     * 
     * 
     */
    qrCodeAuthControllerGetCode1(extraHttpRequestParams?: any): Observable<string>;

    /**
     * 
     * 
     * @param apiRequestQrCodeAuthLoginModel 
     */
    qrCodeAuthControllerLogin0(apiRequestQrCodeAuthLoginModel: ApiRequestQrCodeAuthLoginModel, extraHttpRequestParams?: any): Observable<ApiResponseAuthRefreshModel>;

    /**
     * 
     * 
     * @param apiRequestQrCodeAuthLoginModel 
     */
    qrCodeAuthControllerLogin1(apiRequestQrCodeAuthLoginModel: ApiRequestQrCodeAuthLoginModel, extraHttpRequestParams?: any): Observable<ApiResponseAuthRefreshModel>;

}
